/** @jsx jsx */
import { jsx } from "theme-ui";
import { CompoundButton, Icon, IconButton } from "office-ui-fabric-react";

import PropTypes from "prop-types";

export const IkonButton = ({ color, background, ...props }) => {
  return (
    <IconButton
      styles={{
        root: { color, backgroundColor: background },
        rootDisabled: { opacity: 0.5 },
        rootHovered: {
          border: "solid 1px",
          borderColor: color,
          color,
          backgroundColor: background,
          background: "rgba(0, 0, 0, .1)",
          backgroundBlendMode: "darken",
        },
      }}
      {...props}
    />
  );
};

IkonButton.propTypes = {
  iconName: PropTypes.string.isRequired,
  color: PropTypes.string,
  background: PropTypes.string,
};

IkonButton.defaultProps = {
  color: "black",
  background: "transparent",
};

export const IkonTextButton = ({
  iconName,
  text,
  color,
  background,
  ...restprops
}) => {
  return (
    <CompoundButton
      styles={{
        root: {
          minHeight: "50px",
          color,
          backgroundColor: background,
          border: "none",
        },
        rootDisabled: { opacity: 0.5 },
        rootHovered: {
          backgroundColor: background,
          background: "rgba(0, 0, 0, .1)",
          backgroundBlendMode: "darken",
        },
        description: {
          color,
        },
      }}
      {...restprops}
      text={
        <div sx={{ textAlign: "center" }}>
          <Icon iconName={iconName} />
        </div>
      }
      secondaryText={text}
    />
  );
};

IkonTextButton.propTypes = {
  iconName: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  color: PropTypes.string,
  background: PropTypes.string,
};

IkonTextButton.defaultProps = {
  color: "black",
  background: "transparent",
};
